import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAppBadge } from "../hooks/useAppBadge";
import { notificationQueryKeys } from "../hooks/useNotificationsQuery";

export const SYNC_APP_BADGE_MESSAGE_TYPE = "SYNC_APP_BADGE";

/**
 * Syncs the OS app-icon badge with server unread notification count.
 */
export const AppBadgeSync = () => {
  const queryClient = useQueryClient();

  useAppBadge();

  useEffect(() => {
    const handleServiceWorkerMessage = (event: MessageEvent) => {
      if (event.data?.type !== SYNC_APP_BADGE_MESSAGE_TYPE) {
        return;
      }

      void queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.all,
      });
    };

    navigator.serviceWorker?.addEventListener(
      "message",
      handleServiceWorkerMessage,
    );

    return () => {
      navigator.serviceWorker?.removeEventListener(
        "message",
        handleServiceWorkerMessage,
      );
    };
  }, [queryClient]);

  return null;
};
